import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import { Separator } from 'src/theme/styled'
import styled from 'styled-components'

export const Container = styled.div<{ $color?: string }>`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  gap: ${pxToRem(16)};
  overflow: hidden;
  background-color: ${({ $color }) => $color};

  min-height: ${pxToRem(312)};
  padding: ${pxToRem(24)};

  @media ${mq(sizes.desktop)} {
    min-height: ${pxToRem(380)};
    padding: ${pxToRem(40)};
  }
`

export const Data = styled(motion.span)`
  ${({ theme }) => theme.textStyles.m375_keyNumbersSmall}
  display: flex;
  align-items: baseline;
  gap: 0.3em;
  @media ${mq(sizes.big)} {
    ${({ theme }) => theme.textStyles.d1440_keyNumbersSmall}
  }
`
export const Datum = styled.span`
  ${({ theme }) => theme.textStyles.m375_keyNumbers}
  &:not(:first-child) {
    ${({ theme }) => theme.textStyles.m375_keyNumbersSmall}
  }
  @media ${mq(sizes.big)} {
    ${({ theme }) => theme.textStyles.d1440_keyNumbers}
    &:not(:first-child) {
      ${({ theme }) => theme.textStyles.d1440_keyNumbersSmall}
    }
  }
`

export const _Separator = styled(Separator)`
  display: block;
  margin-top: auto;
  opacity: 0.3;
`

export const Complement = styled.span<{ $height?: number }>`
  ${({ theme }) => theme.textStyles.m375_bodyBig}
  --height: ${({ $height }) => ($height ? pxToRem($height) : 'auto')};
  display: flex;
  flex-flow: column;
  min-height: var(--height, auto);
  overflow: hidden;
  @media ${mq(sizes.big)} {
    ${({ theme }) => theme.textStyles.d1440_bodyBig}
  }
`

export const ComplementContent = styled(motion.span)`
  flex: 0 0 auto;
`
